export default __webpack_public_path__ + "static/media/manne-kalavathi.e942ffcf.png";